/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { useApiRequestState } from '../../../utils/api.utils';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { ActivityForm } from '../../pages/common/forms/ActivityForm';
import { ConnectedDialog } from '../ConnectedDialog';
import { IActivityFormDialogProps } from './types';

export const ActivityFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();

  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'activityFormDialog',
  ) as IActivityFormDialogProps;
  const [showLoader, error] = useApiRequestState('updateActivity');

  const onClose = useCallback(() => {
    dispatch(closeDialog('activityFormDialog'));
  }, [dispatch]);
  return (
    <ConnectedDialog dialogKey="activityFormDialog">
      <div className="popup new_todo_popup" style={{ display: 'block' }}>
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            {'Edit Activity'}

            <span className="close-popup close" onClick={onClose}>
              {!error && !showLoader && <i className="icon-close" />}
              {showLoader && <span className="css-loader" style={{ height: 20, width: 20 }}></span>}
              {error && !showLoader && <p style={{ color: 'red' }}> Something went wrong </p>}
            </span>
          </div>
          <div className="panel-body" style={{ maxHeight: '619.1px' }}>
            <ActivityForm {...props} />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
